import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class FaviconsService {
  private readonly elementId = 'zonar-favicon-node';
  private readonly nativeDocument?: Document;
  // This is specifically base64 encoded because we do not currently have the capability to bundle static assets.
  // Note this is the 32 px favicon.
  readonly favicon =
    'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAICUlEQVRYhcWXW3BT1xWGv3Mk2ZZky5Zl2QJfMbbjC9gGU' +
    'hpiBwoZcwlTCmkaw0AISYB0kt7STF2g0wfyAIlL0pf2AUJCGqCGFAgThqsLlGsYwGDsUBt8A9nGF91syZYs6UinD5KMM5SEtmS6nzTaZ+' +
    '/177X/vf5/CTzqqKpNBhYBs4FSIAvQhGfdwB2gHjgNfEF1Rf+jbCs8QuBSYD3wPKB8RLgScADYTHVF/X8HoKpWB7wPvAqIkb+TtSpmZOj' +
    'IS9Jg0KgAsLn93La6+dLspH/YP3aXILAd+A3VFc5HB1BVWwx8DmQDqESB5aUpVBYnY3P7OX9nkGaLG5s7FMygUZFv1FCeFY9Bo2JvQz+7' +
    '6/vwB+XIju3AEqorGr4dQFVtOXAY0AHMz9VTNSuTPQ397LzWi0cK/vuMhYdaKfLSVBNLi5OpPnOXYy2OyJQTWEh1xfmHAwid/BygEwV4d' +
    '1422igFVUfbGPaHAucnqVmYb6B0fBz6GAUCYB8JUH/PxeFmG81WDwBalUj1gokM+wKsO95OOBlO4JmxmRDGBNcB14FsUYAdP87nbMcAH9' +
    'X1AlCWoWPD7EzMA14O3rRwtduFzSMBYFAreTI1jh8VGclMiGbT6btcMIeu/LVpJmZOSOCV/c0REO3AlAgnxgL4EFgNUD0/m9sWN9vrelE' +
    'IAu/Nz0YXo2TD8TasbukbryBJo2TTvIk4RyR+e6ydgCyzepqJPKOGqmPtkc+2U12x5j6AUOqvA+L8XD0/LEjizS9aUAgCuyoLONxkZdeN' +
    '0LPOSYxh7fTxlJhiCcihIykEgRu9Q2y7fI9W+wgAK0qSWViQxIq9TQRkmT8vyuVQkzXCiWA4Cw0RAHuBF6MUAideLWHhJw0M+4O8/9xEr' +
    'ne72HWjH6UosHleNmm6aP54oZPLXa6vnXx6WhxvlaXT5fSy/ng7UlBmRUkyU1LjePtIG1qVyOFVxcz9+Aa+gAzwGdUVlUK4wnUDylemmo' +
    'hSCGy90kN5ho6V08ax9vNbqESBPcuK+Kyhj72NllHypMdHAdA56CPy4ConG3mxOIWlNTfxB2W2LXmCT+t6OG928vr3xuELyOy41guhYpU' +
    'qUFW7GvgQ4OiqYp7f9RUeKciRlyez8m9NWN0S1fMncq3byZ5GCypRYN2sDGZP1NMSZnxukprTbQ7ePWPGH5RZOtnI1FQdVcfaSNIo+fQn' +
    'BTz3l0bUSpEDKyax4JPRR7BGBJ4FMGlV2D0SHilIgVGDecCL1S2RkxhDenw0exotRCkE9i8vosXmYc72el4/eIvXD95izvZ6Wmwe9i0vI' +
    'kohsKfRQnp8NDmJMVjdEuYBLwVGDR4piN0jYdKqIgCeVVC28h3AWJGjx+6RuNrt4uWpJs7dGaDVPsK6WRl8XNdDt9PH72ZncbZjgJqGfq' +
    'IUAkuKjJSMi6XD7uF6zxACMosKjZztGKBzcISXppiobXUgBYOUZSbwpdlJSqwKfYwyUi9EkZCqkWfU0mxxA1A6PparYZKVmGK53OVCFGD' +
    'WhHj+2hAi5JFVxeQkqknRRnHitVK0KpGaBgs/yIpHFOByl4sSUywAV7tclI4P/W62uMkzaiMZyFISllS9Wol12AeAQa3C6vaDIIySK10X' +
    'TYstdOezsxO40uXiHx0O+oZCBFxSZGRXfR+37R7SddHcHfSOrrW6/RjUobRbh33o1aOiqhlVuQeG8KBMRDaUAjJRCpEel48dLxSSa1AjB' +
    'eVvkNaHz4iEzAQOj0SSNvSsbB4/SWGUkaXmQS95iWoAztwZINeg5s2nUmmzuVk7I50UjYJnMnXkJapx+QJEK4TRtUkaJTZPSDmTtFE4PB' +
    'JrpqUAuBWUrVwOGI0aJRMS1VztdpGtV6NSCLTaRyg2aRkckeh2+sjUq0mNU9HY52ZvYz9SUKbZ4mbj3zvYND+HIa+E2elj6jgtMjK6GCW' +
    '1rQ5mTognKEOcSiTPqOGOw0N6fDQXzM4WEWgAuGR2Up6VAMCRWzYWFxoB2Hb5Hm+VpQPw3pm7LC1JYWlxMkEZTrUPcLzFQYdjhJ3Xevn9' +
    '3Bxu9w9hGfbz0++nset6L798ajyLC42cbXdQlKKlPCuB+nuuSDVsEIGTAL3DfgxqJWqlSJPFTUZCNEkaJa32EToHvSydbMQXkHlh901yD' +
    'WpOrS5l6+In2Lr4CU6tLiU2WkH+lousn5ONUauic9DL7OwETncMkJEQTUGKlhMtdhLVSgpTYjnTMQhw8rGX4l/MSGXzglx+drAJWZZ5O' +
    'ktPzfVeZmUn0OPy4QvIZMRHsfG0WQJSxbB7PQCw+0Yfy0pT0KpEzpuduLwSK0qS8QdlKmtu8mSajprKQqanxSED5kEf5nDw6Wlx1FQWk' +
    'p4QQ/6Wi7wxI520+BhcXolJJi37vrKwrDSFS+ZBzINegANUV/R/Z3L8q6dTeWduDhuO3sYy7Gdmtp5DTVbKM3VsPGUO+oPyGDkOgXjsh' +
    'uSD853sWz6JU612opQilzud9A75OH/XOWpIFKMry1aeASoB/ck2Bz+fkYZBo6Tu3hAnWh3Y3X4+WJhDeVYCUiDIQFi4IGTJZmbF8/YzG' +
    'ayaZuJPF7v4qK4Xly9AYoySX8/MZGddD3q1kv3/tLUDz3Nhp3dsnYlk4T82pQCObzGlW851cmhlMW8cbHbW9Qw/xJTeB/Gd2HKjRuW88' +
    'uaUeVnG+Etjv/8fGpNhbGE+GDRK8o3ax9SY3AehA/5AiJiP1JpdMjvpeyyt2deB/J+a0weBfCft+b8ANuzJabSVR3gAAAAASUVORK5CYII=';
  constructor(platform: Platform, @Inject(DOCUMENT) document?: any) {
    // IE doesn't like the favicon service :(
    this.nativeDocument = document as Document;
    if (!platform.TRIDENT) {
      this.removeExternalLinkElements();
      this.addNode(this.favicon);
    }
  }

  addNode(imgBase64: string): void {
    if (this.nativeDocument) {
      const linkElement = document.createElement('link');
      linkElement.setAttribute('id', this.elementId);
      linkElement.setAttribute('rel', 'icon');
      linkElement.setAttribute('type', 'image/png');
      linkElement.setAttribute('href', `data:image/png;base64,${imgBase64}`);
      this.nativeDocument.head.appendChild(linkElement);
    }
  }

  removeExternalLinkElements(): void {
    let linkElements: NodeListOf<Element>;
    if (this.nativeDocument) {
      linkElements = this.nativeDocument.querySelectorAll(`link[ rel ~= 'icon' i]`);
      for (const linkElement of Array.from(linkElements)) {
        linkElement.parentElement.removeChild(linkElement);
      }
    }
  }
}
